import { Box } from '@mui/material'
import MoreActionDialog from 'components/common/Dialog/MoreActionDialog'

export const addManufacturerAdminColumn = [
    { title: "Brand Id", field: "brand_id" },
    { title: "Brand Name", field: "brand_name" },
    // {
    //     title: 'Action', render: (rowData) =>
    //         <Box display='flex'>
    //             <MoreActionDialog
    //                 rowData={rowData}
    //             />
    //         </Box>
    // }
]